// Hero Banner Swiper slider initialization
document.addEventListener('DOMContentLoaded', function () {
    if (window.Swiper) {
        new Swiper('.hero-swiper', {
            loop: true,
            navigation: {
                nextEl: '.hero-next',
                prevEl: '.hero-prev',
            },
            effect: 'fade',
                autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });
    }
});

// Produt slider initialization

document.querySelectorAll('.product-swiper').forEach((swiperEl, index) => {
  new Swiper(swiperEl, {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 39,
    navigation: {
      nextEl: `.product-button-next-${index}`,
      prevEl: `.product-button-prev-${index}`,
    },
    breakpoints: {
      480: { slidesPerView: 2.1 },
      576: { slidesPerView: 2.5, spaceBetween: 16 },
      768: { slidesPerView: 2.8, spaceBetween: 20 },
      992: { slidesPerView: 3.5 },
      1201: { slidesPerView: 4, spaceBetween: 25 },
      1366: { slidesPerView: 4, spaceBetween: 39 },
    },
  });
});


 swiper = new Swiper('.customer-swiper', {
  slidesPerView: 1,
  centeredSlides: false,
  spaceBetween: 16,
  navigation: {
    nextEl: '.customer-button-next',
    prevEl: '.customer-button-prev',
  },
  breakpoints: {
      480: { slidesPerView: 1 },
      576: { slidesPerView: 1.2,
        spaceBetween: 16
       },
      768: { slidesPerView: 1.5,
        spaceBetween: 20
       },
      992: { 
        slidesPerView: 1.8,
        spaceBetween: 25
      },
      1201: { 
        slidesPerView: 2.2,
        spaceBetween: 30
    },
      1366: { 
            slidesPerView: 2.2,
            spaceBetween: 40 
        },
  },
});

    
// Select Picker

$(function () {
    $('select').selectpicker();
});